
export default function authHeader(list){
  const user = JSON.parse(localStorage.getItem('user'));
  const token = localStorage.getItem('token');
  const listHeader = list === "allItems"? {'x-instaant-do-single-pagination': true}: false
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', 'X-INSTAANT-DBE-SESSION': user?.session_id , ...listHeader};
}


